module.exports = __webpack_public_path__ + "static/media/12.fa04b787.jpg";